module.exports = __webpack_public_path__ + "src/assets/img/screen01.76837471.jpg";